module.exports = __webpack_public_path__ + "static/media/logo-white.ef1656a3.png";